<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { isMobile } from '@/utils/tool'
export default {
  name: 'App',
  mounted() {
    this.init()
  },
  methods: {
    // 判断登录设备类型
    init() {
      if (isMobile()) {
        this.$router.replace('/mobilePage')
      }
    },
  },
}
</script>
<style>
body {
  font-family: 'sourcehansans' !important;
}
</style>
